import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { TaskPrioritySelectField } from '../../TaskPrioritySelectField'
import {
  TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME,
  TASK_EDIT_PRIORITY_FIELDS_INITIAL_VALUES,
} from '../TaskEditPriorityModal.constants'

function FormFields({ actionTypes, typeSelectProps }) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: TASK_EDIT_PRIORITY_FIELDS_INITIAL_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <TaskPrioritySelectField
          Field={FieldStackedLabel}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('Task.EditPriorityFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            label: t('Task.EditPriorityFieldLabelKey'),
          }}
          name={TASK_EDIT_PRIORITY_FIELDS_FIELD_NAME}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
